<template>
  <div class="merchant">
    <!-- <h1>acquirer</h1> -->
    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters>
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet class="pa-2">
          <!-- <v-breadcrumbs :items="['Merchants']"></v-breadcrumbs> -->
          <v-breadcrumbs
            :items="[{ text: $t('merchants'), disabled: true, href: '/' }]"
          ></v-breadcrumbs>
        </v-sheet>
      </v-col> 
      
      <v-col cols="auto">
        <v-sheet class="pa-2">
          <v-btn
            class="button_size"
            color="blue"
            prepend-icon="mdi-plus"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_USER_ASSIST')
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            {{ $t("add_merchant") }}
          </v-btn>
          <divider></divider>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet class="pa-2">
          <v-btn
            class="button_size"
            color="orange"
            prepend-icon="mdi-upload"
            @click="compose_excel"
            v-if="
              this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_USER_ASSIST')
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            <span class="text_color"> {{ $t("batch_upload") }}</span>
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="search_row">
      <v-col cols="4" class="me-auto">
        <v-sheet class="pa-2">
        <v-text-field
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          :label="$t('search')"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchData"
        ></v-text-field>
      </v-sheet>
      </v-col>
      <!-- FOR USER  open a dialog to select all or an acquirer before exporting-->
      <v-col cols="auto mt-2">
        <v-sheet>
          <v-btn variant="text" @click="compose_select_acquirer" v-if="this.global_permissions.includes('ROLE_USER_ADMIN') || this.global_permissions.includes('ROLE_USER_ASSIST') ">
            <span class="mr-1">{{ $t("export") }}</span>
            <v-icon color="grey-darken-1">mdi mdi-download</v-icon>            
          </v-btn>
        </v-sheet>
      </v-col>      
      <!-- <v-col cols="auto mt-2">
        <v-sheet v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN') || this.global_permissions.includes('ROLE_STAFF_USER') ">
          <v-btn variant="text">
            <span class="mr-1">{{ $t("export") }}</span>
            <v-icon color="grey-darken-1">mdi mdi-download</v-icon>
            <v-menu activator="parent">
              <v-list>
                <v-list-item>
                  <download-excel                    
                    class="btn btn-default"
                    :data="exportMerchants"
                    :fields="json_fields"
                    worksheet="My Worksheet"
                    name="Merchants.xls"
                  >
                    <v-btn variant="text" @click="exportMerchantDataForAdmin">xls</v-btn>
                    
                  </download-excel>
                </v-list-item>
                <v-list-item>
                  <v-sheet>                    
                    <download-excel
                      class="btn btn-default"
                      :data="exportMerchants" 
                      :fields="json_fields"
                      worksheet="My Worksheet"
                      type="csv"
                      name="Merchants.xls"
                    >
                      <v-btn variant="text" @click="exportMerchantDataForAdmin">csv</v-btn>
                    </download-excel>
                  </v-sheet>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-btn>
        </v-sheet>
      </v-col> -->
      <!-- FOR ADMIN -->
      <v-col cols="auto mt-2">
        <v-sheet>
          <v-btn variant="text" @click="compose_select_organization" v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN') || this.global_permissions.includes('ROLE_STAFF_USER') ">
            <span class="mr-1">{{ $t("export") }}</span>
            <v-icon color="grey-darken-1">mdi mdi-download</v-icon>            
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular

      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-card v-else>
      <v-data-table
        :headers="headers"
        :items="merchants"
        class="elevation-1 custom-table-style"
        :items-per-page="itemsPerPage"
        :items-length="totalItems"
        disable-pagination
        :hide-default-footer="true"
        :fixed-header="true"
        :loading="loading"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip :text="$t('Update')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-2"
                color="green"
                @click="compose_update(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_USER_ADMIN') ||
                  this.global_permissions.includes('ROLE_USER_ASSIST')
                "
                >mdi-pencil-circle</v-icon
              >
            </template>
          </v-tooltip>
          <v-tooltip :text="$t('Delete')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-2"
                color="red"
                @click="compose_delete(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_USER_ADMIN') ||
                  this.global_permissions.includes('ROLE_STAFF_ADMIN')
                "
                >mdi-delete-circle</v-icon
              >
            </template>
          </v-tooltip>
        </template>

        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              total-visible="7"
              @update:model-value="page"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- ADD DIALOG -->
    <v-dialog v-model="dialog" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5"> {{ $t("add_merchant") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('merchant_name')"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="merchant_data.f_merchantName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('merchant_address')"
                      :readonly="loading"
                      :rules="[required, validateAdress]"
                      clearable
                      v-model="merchant_data.f_merchantAddress"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <!-- <v-autocomplete
                      v-model="merchant_data.f_mccCode"
                      :items="mcc"
                      item-title="mccName"
                      item-value="mccCode"
                      :label="$t('merchant_mcc')"
                      v-model:search="search"
                      :placeholder="$t('Start typing')"
                      hide-no-data
                      hide-selected
                      no-filter
                      required
                    >
                    </v-autocomplete> -->
                    <v-autocomplete
                      v-model="merchant_data.f_mccCode"
                      :items="mcc"
                      item-title="mccName"
                      item-value="mccCode"
                      :label="dynamicLabel"
                      v-model:search="search"
                      :placeholder="$t('Start typing')"
                      hide-no-data
                      hide-selected
                      no-filter
                      required
                >
                </v-autocomplete>
                  </v-col>
                  <!-- <v-col cols="6">                                 
                        <v-select
                          :items="activity"
                          item-title="mccName"
                          item-value="mccCode"                          
                          label="Select Code"                          
                          :rules="[required]"
                          v-model="merchant_data.f_mccCode"
                        ></v-select>

                      </v-col> -->
                  <v-col cols="12">
                    <v-select
                      :items="acquirer"
                      item-title="acquirerName"
                      item-value="acquirerId"
                      :label="$t('select_acquirer')"
                      :rules="[required]"
                      v-model="merchant_data.f_acquirerId"
                    ></v-select>
                  </v-col>
                  <!-- <v-col cols="12" sm="6">                                 
                        <v-select
                          :items= "organization"
                          item-title="orgName"
                          item-value="orgId"                          
                          label="Select Organization*"                          
                          required
                          v-model="merchant_data.f_orgId"
                        ></v-select>                                              
                      </v-col> -->
                </v-row>
              </v-container>
              <small>* {{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">{{
                $t("Close")
              }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="addMerchant"
                >{{ $t("Save") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD DIALOG -->

    <!-- UPDATE  DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("update_merchant") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('merchant_name')"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="merchant_data.f_merchantName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('merchant_address')"
                      :readonly="loading"
                      :rules="[required, validateAdress]"
                      clearable
                      v-model="merchant_data.f_merchantAddress"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <!-- <v-text-field label="Category Code" :readonly="loading" :rules="[required]" clearable v-model="merchant_data.f_categoryCode" ></v-text-field> -->
                    <!-- <v-autocomplete
                      v-model="merchant_data.f_mccCode"
                      :items="mcc"
                      item-title="mccName"
                      item-value="mccCode"
                      :label="$t('merchant_mcc')"
                      v-model:search="search"
                      :placeholder="$t('Start typing')"
                      hide-no-data
                      no-filter
                      required
                    ></v-autocomplete> -->

                    <v-autocomplete
                      v-model="merchant_data.f_mccCode"
                      :items="mcc"
                      item-title="mccName"
                      item-value="mccCode"
                      :label="dynamicLabel"
                      v-model:search="search"
                      :placeholder="$t('Start typing')"
                      hide-no-data
                      hide-selected
                      no-filter
                      required
                >
                </v-autocomplete>

                  </v-col>
                  <!-- <v-col cols="6">                                 
                        <v-select
                          :items="activity"
                          item-title="activity"
                          item-value="mccCode"                          
                          label="Select Activity"                          
                          :rules="[required]"
                          v-model="merchant_data.f_mccCode"
                        ></v-select>                      
                      </v-col> -->
                  <v-col cols="12">
                    <v-select
                      :items="acquirer"
                      item-title="acquirerName"
                      item-value="acquirerId"
                      :label="$t('select_acquirer')"
                      :rules="[required]"
                      v-model="merchant_data.f_acquirerId"
                    ></v-select>
                  </v-col>
                  <!-- <v-col cols="12" sm="6">                                 
                        <v-select
                          :items= "organization"
                          item-title="orgName"
                          item-value="orgId"                          
                          label="Select Organization*"                          
                          required
                          v-model="merchant_data.f_orgId"
                        ></v-select>                                              
                      </v-col> -->
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_update = false">{{
                $t("Close")
              }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="updateMerchant"
                >{{ $t("Update") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE  DIALOG -->

    <!-- DELETE  DIALOG -->
    <!-- <v-dialog
              v-model="dialog_delete"
              persistent
              width="500"
            >              
              <v-card>
                <v-card-title>
                  <div class="container">
                  <span class="text-h5">Do you want to delete?</span></div>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                                           
                    </v-row>
                  </v-container>
                  
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue-darken-1" variant="text" @click="dialog_delete = false">Close</v-btn>                  
                  <v-btn color="blue-darken-1" variant="text" @click="deleteMerchant">Delete</v-btn>                  
                </v-card-actions>
              </v-card>
            </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">{{ $t("deleteFile") }}</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          {{ $t("deleteText") }}
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteMerchant">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END UPDATE DIALOG -->

    <!-- UPLOAD  DIALOG -->
    <v-dialog v-model="dialog_excel" persistent width="500">
      <v-card class="pa-3">
        <div class="container">
          <span style="text-align: center">{{ $t("batch_upload") }}</span>
        </div>
        <span style="text-align: center">
          <!-- THIS ALLOWS ME TO DOWNLOAD .XLS FILE -->
          <!-- <download-excel
                        class="btn btn-default"
                        :data="template_merchants"
                        :fields="template_json_fields"
                        worksheet="Merchants"
                        name="Merchants.xls"
                      >
                        <v-btn density="compact" color="black">Download Merchant Template</v-btn>
                      </download-excel> -->
          <!-- THIS ALLOWS ME TO DOWNLOAD .XLXS FILE -->
          <vue-excel-xlsx
            class="btn btn-default"
            :data="data1"
            :columns="template_columns"
            :file-name="'Merchants'"
            :file-type="'xlsx'"
            :sheet-name="'Merchants'"
          >
            <v-btn
              density="compact"
              color="white"
              height="48"
              min-width="164"
              >{{ $t("download_template") }}</v-btn
            >
            <!-- Download Template -->
          </vue-excel-xlsx>
        </span>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-card-title> </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <!-- <v-file-input show-size clearable label="File input" v-model="file" @change="handleFileUpload( $event )"></v-file-input> -->
                <v-file-input
                  show-size
                  clearable
                  :label="$t('file_input')"
                  @change="handleFileUpload($event)"
                ></v-file-input>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="dialog_excel = false">{{ $t('Close') }}</v-btn>
            <v-btn
              color="blue-darken-1"
              variant="text"
              @click="uploadMerchantFile"
              >{{ $t('Upload') }}</v-btn
            >
          </v-card-actions>
        </v-form>
        <div class="container">
          <small style="color: red">
            * {{ $t('file_size') }}</small
          >
          <small style="color: red">
            {{ $t('uplaod_text') }}</small
          >
        </div>
      </v-card>
    </v-dialog>
    <!-- END UPLOAD FILE DIALOG -->

    <!-- SELECT ACQUIRER FOR EXPORT -->
    <v-dialog v-model="dialog_select_acquirer" persistent width="700">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">Export Data</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">                                 
                      <!-- <v-select
                        :items="optionsWithSelectAll"
                        item-title="acquirerName"
                        item-value="acquirerId"                          
                        label="Select Acquirer"                          
                        :rules="[required]"                        
                        v-model="select_acquirer.f_acquirerId"
                      >                      
                      </v-select>  --> 
                      <v-select
                        :items="acquirer"
                        item-title="acquirerName"
                        item-value="acquirerId"                          
                        label="Select Acquirer"                          
                        :rules="[required]"                        
                        v-model="select_acquirer.f_acquirerId"
                      >                      
                      </v-select>                    
                    </v-col>                 
                  
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_select_acquirer = false">{{
                $t("Close")
              }}</v-btn>
              
              <v-btn variant="text" @click="exportMerchantData(this.select_acquirer.f_acquirerId)">
                <span class="mr-1">{{ $t("export") }}</span>
                <v-icon color="grey-darken-1">mdi mdi-download</v-icon>                
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END SELECT ACQUIRER FOR EXPORT -->

    <!-- SELECT ORGANIZATION FOR EXPORT -->
    <v-dialog v-model="dialog_select_organization" persistent width="700">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">Export Data</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">                                 
                      <!-- <v-select
                        :items="orgWithSelectAll"
                        item-title="orgName"
                        item-value="orgId"                          
                        label="Select organization"                          
                        :rules="[required]"                        
                        v-model="select_acquirer.f_acquirerId"
                      >                      
                      </v-select>   -->  
                      <v-select
                        :items="organization"
                        item-title="orgName"
                        item-value="orgId"                          
                        label="Select organization"                          
                        :rules="[required]"                        
                        v-model="select_acquirer.f_acquirerId"
                      >                      
                      </v-select>                    
                    </v-col>                 
                  
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_select_organization = false">{{
                $t("Close")
              }}</v-btn>
              
              <v-btn variant="text" @click="exportMerchantDataForAdmin(this.select_acquirer.f_acquirerId)">
                <span class="mr-1">{{ $t("export") }}</span>
                <v-icon color="grey-darken-1">mdi mdi-download</v-icon>                
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END SELECT ORGANIZATION FOR EXPORT -->

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Role",
  props: {
    msg: String,
  },
  data() {
    return {
      name: "",
      emits: ["reload"],
      merchants: [], //used
      exportMerchants: [],
      acquirer: [],
      organization: [], 
      activity: [],
      mcc: [],

      dialog: false,
      dialog_update: false,
      dialog_delete: false,
      dialog_excel: false, //for upload
      dialog_select_acquirer: false,
      dialog_select_organization: false,

      merchant_data: {
        //used
        f_merchantName: "",
        f_merchantAddress: "",
        //f_categoryCode: '',
        f_mccCode: "",
        f_acquirerId: "",
        //f_orgId: '',
      },

      /* merchant_file:{ 
          f_fileUpload: ''          
        }, */
      file: "",

      merchantId: "",
      search: "",
      selectedMcc: '',
      headers: [
        {
          title: "ID",
          align: "start",
          sortable: false,
          key: "id",
        },
        { title: this.$t("merchant_name"), key: "merchantName" },
        { title: this.$t("merchant_address"), key: "merchantAddress" },
        { title: this.$t("merchant_activity"), key: "mcc.mccCode" },
        { title: this.$t("Acquirer"), key: "acquirer.acquirerName" },
        { title: this.$t("organization"), key: "acquirer.organization.orgName" },
        { title: this.$t("Actions"), key: "actions", sortable: false, width: "100px" },
      ],

       //FOR EXPORT
       json_fields: {
        "ID": "id",
        "Merchant Name": "merchantName",
        "Merchant Address": "merchantAddress",
        "Merchant Activity": "mcc.mccCode",
        "Acquirer name": "acquirer.acquirerName",
      },

      //THIS IS USED TO CREATE A TEMPLATE XLS FILE FOR DOWNLOAD
      template_merchants: [""],
      template_json_fields: {
        Name: "",
        Location: "",
        "Category Code": "",
        "Acquirer ID": "",
        "Created By": "",
      },

      //THIS IS USED TO CREATE A TEMPLATE XLXS FILE FOR DOWNLOAD
      //THE FIELD HAS TO BE ACCORDING TO THE NAMING IN THE ENTITY CLASS
      //NB: THE USER HAS TO DOWNLOADED ET RE SAVE  THE .XLXS FILE BEFORE IT WILL WORK
      template_columns: [
        {
          label: "Name",
          field: "merchantName",
        },
        {
          label: "Location",
          field: "merchantAddress",
        },
        {
          label: "Category Code",
          field: "mcc.mccCode",
        },
        {
          label: "Acquirer ID",
          field: "acquirer.id",
        },
        {
          label: "Created By",
          field: "createdBy",
        },
      ],
      // data1   HERE IS ACCORDING THE MERCHANT ENTITY
      data1: [
        {
          merchantName: "",
          merchantAddress: "",
          mcc: {
            mccCode: "",
          },
          acquirer: {
            id: "",
          },
          createdBy: "",
        },
      ],

      //form
      form: false,
      loading: true,
      exist: false,

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,

      //selection
      selected: [],

      //select acquirer
      select_acquirer: {
        f_acquirerId: "",        
      },      
      

    };
  },

  computed: {
    pageCount() {
      // console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      let count = Math.ceil(this.totalItems / this.itemsPerPage);
      // console.log("ssss11 count : ", count);
      //return Math.ceil(this.totalItems / this.itemsPerPage)
      return count;
    },

    dynamicLabel() {
      return this.selectedMcc
        ? `${this.$t('merchant_selected_mcc')} - ${this.selectedMcc}`
        : this.$t('merchant_mcc');
    },

    optionsWithSelectAll(){
      return [{acquirerId: "all", acquirerName:"All"}, ...this.acquirer]
    },

    orgWithSelectAll(){
      return [{orgId: "all", orgName:"All"}, ...this.organization]
    },
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },

    onUpdatePageHandler(newPage) {
      this.page = newPage;
      //this.fetchData()
    },

    onItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.fetchData();
    },

    //auto-complete
    search(newSearch) {
      if (newSearch.length >= 2) {
        this.searchMcc(newSearch);
      } else {
        this.mcc = [];
      }
    },

    'merchant_data.f_mccCode'(newMerchantMcc) {
    const selectedMcc = this.mcc.find(
      (mcc) => mcc.mccCode === newMerchantMcc // Match with mccCode, not id
    );
    // Update the selectedMcc when a new MCC is selected
    this.selectedMcc = selectedMcc ? selectedMcc.mccName : '';
  },
  },

  created() {
    //this.initialize()
  },

  methods: {
    resetData() {
      this.query = "";
      this.fetchData();
    },

    resetInput() {
      this.merchant_data.f_merchantName = "";
      this.merchant_data.f_merchantAddress = "";
      this.merchant_data.f_mccCode = "";
      this.merchant_data.f_acquirerId = "";
    },

    onSubmit() {
      if (!this.form) return;
    },

    required(v) {
      return !!v || "Field is required";
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    compose() {
      this.dialog = true;
      this.resetInput();
      this.checkTokenExpiry();
      this.requests_handler();
    },

    compose_update(id) {
      this.merchantId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.merchantId = id;
      this.dialog_delete = true;
    },

    compose_excel() {
      this.dialog_excel = true;
    },

    compose_select_acquirer() {
      this.dialog_select_acquirer = true;
      this.checkTokenExpiry();
      this.requests_handler3();
    },

    compose_select_organization() {
      this.dialog_select_organization = true;
      this.checkTokenExpiry();
      this.requests_handler4();
    },

    requests_handler4() {
      axios
        .all([
          axios.get(window.baseurl + "organizations", {            
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((org_response) => {
            // console.log("data1", acq_response.data);

            if (org_response.status == 200) {
              if (
                org_response.data.records != null &&
                org_response.data.records.length > 0
              ) {
                let i = 0;
                this.organization = []; //remove all items from array
                for (i = 0; i < org_response.data.records.length; i++) {
                  this.organization.push({
                    orgId: org_response.data.records[i].id,
                    orgName: org_response.data.records[i].orgName,
                  });
                  
                }
              }
            }
          })
        );
    }, //end of requests_handler4 method

    requests_handler3() {
      axios
        .all([
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params: { pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((acq_response) => {
            // console.log("data1", acq_response.data);

            if (acq_response.status == 200) {
              if (
                acq_response.data.records != null &&
                acq_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirer = []; //remove all items from array
                for (i = 0; i < acq_response.data.records.length; i++) {
                  this.acquirer.push({
                    acquirerId: acq_response.data.records[i].id,
                    acquirerName: acq_response.data.records[i].acquirerName,
                  });
                  //console.log("acquirer", this.acquirer)
                }
              }
            }
          })
        );
    }, //end of requests_handler3 method

    requests_handler() {
      axios
        .all([
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params: { pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          /* axios.get(window.baseurl+"mcc" , 
              {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
            ), */
          //axios.get("http://localhost:8080/api/org/get/4cb06b44-f37c-463b-9d69-ef7fe3ba7618")
        ])
        .then(
          axios.spread((acq_response) => {
            // console.log("data1", acq_response.data);
            //console.log("data2", act_response.data)

            //if response data is an object // handle it as below
            //if response data is an array // handle it as below
            if (acq_response.status == 200) {
              if (
                acq_response.data.records != null &&
                acq_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirer = []; //remove all items from array
                for (i = 0; i < acq_response.data.records.length; i++) {
                  this.acquirer.push({
                    acquirerId: acq_response.data.records[i].id,
                    acquirerName: acq_response.data.records[i].acquirerName,
                  });
                  //console.log("acquirer", this.acquirer)
                }
              }
            }
            //if response data is an array // handle it as below
            /* if(act_response.status == 200){  
                  if(act_response.data.records != null && act_response.data.records.length > 0){
                      let i = 0;
                      this.activity = [];   //remove all items from array
                      for(i=0; i<act_response.data.records.length; i++){                                                    
                          this.activity.push({ mccCode: act_response.data.records[i].mccCode, mccName: act_response.data.records[i].mccName });                          
                          //console.log("activity", this.activity)
                         
                      }                      
                  }                  
              } */

            // if(org_response.status == 200){
            //     this.organization = [];   //remove all items from array
            //     this.organization.push(org_response.data);

            // }
          })
        );
    }, //end of requests_handler method

    async addMerchant() {
      //this.dialog = false
      this.checkTokenExpiry();
      // console.log("form data", this.merchant_data);
      try {
        let result = await axios.post(
          window.baseurl + "merchants",
          {
            merchantName: this.merchant_data.f_merchantName,
            merchantAddress: this.merchant_data.f_merchantAddress,
            //categoryCode:this.merchant_data.f_categoryCode,
            mccCode: this.merchant_data.f_mccCode,
            acquirer_id: this.merchant_data.f_acquirerId,
            //orgId:this.merchant_data.f_orgId,
            createdBy: this.userEmail,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.warn("result", result);
        if (result.status == 201) {
          //alert("successfull");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message});
          this.$root.vtoast.show({ message: this.$t("merchant_created") });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.waiting_time);
          //this.$router.go();
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "merchants/" + this.merchantId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params: { pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          /* axios.get(window.baseurl+""+"mcc" , 
              {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
            ) , */
          //axios.get("http://localhost:8080/api/org/get/4cb06b44-f37c-463b-9d69-ef7fe3ba7618")
        ])
        .then(
          axios.spread((mer_response, acq_response) => {
            // console.log("data1", mer_response.data);

            //get data for selected id and display data in for dialog
            if (mer_response.status == 200) {
              //this.acquirer_response = acquirer_response.data,
              // console.log("merchant Data", this.mer_response);
              this.merchant_data.f_merchantName =
                mer_response.data.merchantName;
              this.merchant_data.f_merchantAddress =
                mer_response.data.merchantAddress;

              this.merchant_data.f_mccCode = mer_response.data.mcc.mccCode;
              this.selectedMcc = mer_response.data.mcc.mccName;
              this.mcc = [];
              this.mcc.push({
                mccCode: mer_response.data.mcc.mccCode,
                mccName: mer_response.data.mcc.mccName,
              });

              this.merchant_data.f_acquirerId = mer_response.data.acquirer.id;
              //this.merchant_data.f_orgId = org_response.data.orgId
            }

            if (acq_response.status == 200) {
              if (
                acq_response.data.records != null &&
                acq_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirer = []; //remove all items from array
                for (i = 0; i < acq_response.data.records.length; i++) {
                  this.acquirer.push({
                    acquirerId: acq_response.data.records[i].id,
                    acquirerName: acq_response.data.records[i].acquirerName,
                  });
                  // console.log("acquirer", this.acquirer);
                }
              }
            }
            //if response data is an array // handle it as below
            /* if(act_response.status == 200){  
                  if(act_response.data.records != null && act_response.data.records.length > 0){
                      let i = 0;
                      this.activity = [];   //remove all items from array
                      for(i=0; i<act_response.data.records.length; i++){                                                    
                          this.activity.push({ mccCode: act_response.data.records[i].mccCode, mccName: act_response.data.records[i].mccName });                          
                          console.log("mcc", this.activity)
                         
                      }                      
                  }                  
              }  */

            // if(org_response.status == 200){
            //     this.organization = [];   //remove all items from array
            //     this.organization.push(org_response.data);

            // }
          })
        );
    }, //end of requests_handler 2 method

    async updateMerchant() {
      //this.dialog_update = false
      this.checkTokenExpiry();
      // console.log("update merchant role id", this.merchantId);
      // console.log("update form merchant..", this.merchant_data);
      try {
        let result = await axios.put(
          window.baseurl + "" + "merchants/" + this.merchantId,
          {
            merchantName: this.merchant_data.f_merchantName,
            merchantAddress: this.merchant_data.f_merchantAddress,
            mccCode: this.merchant_data.f_mccCode,
            acquirer_id: this.merchant_data.f_acquirerId,
            //orgId:this.merchant_data.f_orgId,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.log("update form merchant result", result);
        if (result.status == 200) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message});
          this.$root.vtoast.show({ message: this.$t("merchant_updated") });
          window.setInterval(() => {
            this.dialog_update = false;
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    async deleteMerchant() {
      this.checkTokenExpiry();
      this.dialog_delete = false;
      try {
        let result = await axios.delete(
          window.baseurl + "merchants/" + "" + this.merchantId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        if (result.status == 204) {
          //alert("successfull deleted");
          //this.show_toast(true, "success", "Deleted");
          // this.$root.vtoast.show({message: result.data.message});
          this.$root.vtoast.show({ message: this.$t("merchant_deleted") });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
      }
    },

    //UPLOAD FILE

    handleFileUpload(event) {
      this.file = event.target.files[0];
    },

    async uploadMerchantFile() {
      this.checkTokenExpiry();
      //console.log("file" + this.file);

      if (this.file) {
        this.loading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        try {
          let result = await axios.post(
            window.baseurl + "merchants/upload",
            formData,
            {
              headers: {
                Authorization: "Bearer " + this.accessToken,
                "content-type": "multipart/form-data",
              },
            }
          );
          //console.warn("result", result);
          if (result.status == 201) {
            //alert("successfull");
            //this.show_toast(true, "success", "Successful");
            this.$root.vtoast.show({ message: this.$t("uploaded") });
            window.setInterval(() => {
              this.dialog_excel = false;
              this.$emit("reload");
            }, this.waiting_time);            
          }
          this.loading = false;
        } catch (error) {
          //this.show_toast(true, "warning", error.message);
          this.loading = false;
          if (error.response.status == 417) {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          } else if (error.response.status == 500) {
            this.$root.vtoast.showError({
              message: error.response.data.detail,
            });
          } else {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          }
        }
      } else {
        //console.log("there are no files.");
        this.$root.vtoast.showError({ message: this.$t("no_file") });
      }
    },

    async fetchData() {
      let result;
      let page2 = this.page - 1;
      this.loading = true;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          /* result = await axios.get(window.baseurl + "merchants", {
                "headers": {'Authorization': 'Bearer ' + this.accessToken} 
              }); */
          result = await axios.get(window.baseurl + "merchants", {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          //console.log("merchant_object", result);
          this.merchants = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_USER_ADMIN") ||
          this.global_permissions.includes("ROLE_USER_ASSIST")
        ) {
          /* result = await axios.get(window.baseurl + "merchants/org/" + this.orgId, {
                "headers": {'Authorization': 'Bearer ' + this.accessToken} 
              }); */
          result = await axios.get(
            window.baseurl + "merchants/org/" + this.orgId,
            {
              params: { page: page2 },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          //console.log("merchant_object", result);
          this.merchants = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.response.data.message });
        this.loading = false;
      }
    },

    async searchData() {
      let result;
      let page2 = this.page - 1; //pagination starts from 1 in vue , in spring boot pgae start from zero
      this.loading = true;
      this.checkTokenExpiry();
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "merchants/search", {
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("search_merchant_object", result);
          this.merchants = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_USER_ADMIN") ||
          this.global_permissions.includes("ROLE_USER_ASSIST")
        ) {
          result = await axios.get(
            window.baseurl + "merchants/org/search/" + this.orgId,
            {
              params: { page: page2, search: this.query },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          //console.log("search_merchant_object", result);
          this.merchants = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.response.data.message });
        this.loading = false;
      }
    },

    async searchMcc(search) {
      // console.log("in searchMcc", search);
      this.checkTokenExpiry();
      let result;

      this.mcc = [];
      //this.loading = true;
      let page2 = this.page - 1;
      if (search.length < 2) {
        this.items = [];
        return;
      }
      try {
        if (
          this.global_permissions.includes("ROLE_USER_ADMIN") ||
          this.global_permissions.includes("ROLE_USER_ASSIST") ||
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "mcc/search", {
            params: { page: page2, search: search },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          //console.log("activity_search_object", result);
          this.mcc = result.data.records;

          /* const hits = result.data.records;
                hits.map(hit => {
                    this.mcc.push(hit)
                }) */
        }
      } catch (error) {
        this.show_toast(true, "warning", error.message);
      }
    },    
    
    //Export

    async downloadExcel(acquirerId) {
      this.loading = true;
      try {
        /* const response = await axios.get(window.baseurl + "merchants/export/acq/" + acquirerId , {
              
              headers: { Authorization: "Bearer " + this.accessToken , 'Accept': 'application/octet-stream' },
            }); */
        const response = await fetch(window.baseurl + "merchants/export/acq/" + acquirerId, {
          method: 'GET',
          headers: {
            'Accept': 'application/octet-stream',
            Authorization: "Bearer " + this.accessToken ,
          },
        }); 
        console.error('response.', response);   
        if (response.status == 200) {
          const blob = await response.blob();  // Convert the response to a blob (binary data)          
          const url = window.URL.createObjectURL(blob);  // Create a URL for the blob
          const link = document.createElement('a');  // Create a temporary download link
          link.href = url;
          // Base file name
          const baseFileName = "Merchant";
          // Get current date and time
          const now = new Date();
          const formattedDate = now.toISOString().slice(0, 19).replace(/:/g, "-");
          // Combine base file name with date and time
          const fileName = `${baseFileName}_${formattedDate}.xlsx`;
          //link.setAttribute('download', 'merchant_data.xlsx');  // Set the file name
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();  // Simulate a click to trigger the download
          document.body.removeChild(link);  // Clean up
        } else {
          console.error('Failed to download the file.');
        }
        this.loading = false;
      } catch (error) {
        console.error('Error downloading the file:', error);
        this.loading = false;
      }
    },

    async downloadExcel2(orgId) {
      this.loading = true;
      try {       
        const response = await fetch(window.baseurl + "merchants/export/org/" + orgId, {
          method: 'GET',
          headers: {
            'Accept': 'application/octet-stream',
            Authorization: "Bearer " + this.accessToken ,
          },
        }); 
        console.error('response.', response);   
        if (response.status == 200) {          
          const blob = await response.blob();  // Convert the response to a blob (binary data)          
          const url = window.URL.createObjectURL(blob);  // Create a URL for the blob
          const link = document.createElement('a');  // Create a temporary download link
          link.href = url;
          // Base file name
          const baseFileName = "Merchant";
          // Get current date and time
          const now = new Date();
          const formattedDate = now.toISOString().slice(0, 19).replace(/:/g, "-");
          // Combine base file name with date and time
          const fileName = `${baseFileName}_${formattedDate}.xlsx`;
          //link.setAttribute('download', 'merchant_data.xlsx');  // Set the file name
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();  // Simulate a click to trigger the download
          document.body.removeChild(link);  // Clean up
        } else {
          console.error('Failed to download the file.');
        }
        this.loading = false;
      } catch (error) {
        console.error('Error downloading the file:', error);
        this.loading = false;
      }
    },

    async downloadExcelAdmin() {
      this.loading = true;
      try {
        
        const response = await fetch(window.baseurl + "merchants/export/all", {
          method: 'GET',
          headers: {
            'Accept': 'application/octet-stream',
            Authorization: "Bearer " + this.accessToken ,
          },
        }); 
        console.error('response.', response);   
        if (response.status == 200) {
          const blob = await response.blob();  // Convert the response to a blob (binary data)          
          const url = window.URL.createObjectURL(blob);  // Create a URL for the blob
          const link = document.createElement('a');  // Create a temporary download link
          link.href = url;
          // Base file name
          const baseFileName = "Merchant";
          // Get current date and time
          const now = new Date();
          const formattedDate = now.toISOString().slice(0, 19).replace(/:/g, "-");
          // Combine base file name with date and time
          const fileName = `${baseFileName}_${formattedDate}.xlsx`;
          link.setAttribute('download', fileName);  // Set the file name
          document.body.appendChild(link);
          link.click();  // Simulate a click to trigger the download
          document.body.removeChild(link);  // Clean up
        } else {
          console.error('Failed to download the file.');
        }
        this.loading = false;
      } catch (error) {
        console.error('Error downloading the file:', error);
        this.loading = false;
      }
    },

    async exportMerchantData(id) {      
      console.log("merchant_object44", id);      
      if(id == "all"){        
        this.downloadExcel2(this.orgId);
      }else{
        this.downloadExcel(id);
      }
      this.dialog_select_acquirer = false;     
    },

    async exportMerchantDataForAdmin(id) {      
      console.log("merchant_object44", id);      
      if(id == "all"){        
        this.downloadExcelAdmin();
      }else{
        this.downloadExcel2(id);
      }
      this.dialog_select_organization = false;
    },

   

    

    /*RULES VALIDATION */

    validateName(value) {
      const regex = /^[A-Za-z0-9-_@#$%^&*()+:;'/,. ]+$/;
      return (
        regex.test(value) ||
        "Name can only contain numbers, letters, spaces, underscores, hyphens, @, #, $, %, ^, &, *, (, ), +, :, ;, ', /, ., and ,"
  );
    },

    validateAdress(value) {
      const regex = /^[A-Za-z0-9-_@#$%^&*()+:;'/,. ]+$/;
      return (
        regex.test(value) ||
       "Address can only contain numbers, letters, spaces, underscores, hyphens, @, #, $, %, ^, &, *, (, ), +, :, ;, ', /, ,, and ."
  );
    },
  },
  //get list of acquirers
  async mounted() {
    this.checkTokenExpiry();

    //get user list
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.search_row {
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
